import styled, { css } from 'styled-components'
import { ControlSize } from 'types'
import { heightFromControlSize } from 'utils'
import { SliderLayoutType } from '..'

const HandleBase = styled.div`
    cursor: ew-resize;
    filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.5));
    position: absolute;
`

export const HandleRectangle = styled(HandleBase)`
    border-radius: 2px;
    box-sizing: content-box;
    height: 100%;
    left: -2px;
    padding: 2px 0;
    top: -2px;
    width: 4px;
`

export const HandleCircle = styled(HandleBase)`
    border-radius: 50%;
    height: 20px;
    left: -10px;
    width: 20px;
`

export const Container = styled.div<{ controlLayout: SliderLayoutType; controlSize: ControlSize; trackColor: string }>`
    position: relative;
    width: 100%;

    ${HandleCircle} {
        margin-top: -10px;
        top: 50%;
    }

    ${({ controlLayout, controlSize, trackColor }) => {
        if (controlLayout === 'circle') {
            return css`
                height: ${heightFromControlSize(controlSize)}px;

                &:before {
                    background: ${trackColor};
                    border-radius: 1px;
                    content: '';
                    display: block;
                    left: 0;
                    height: 2px;
                    margin-top: -1px;
                    position: absolute;
                    top: 50%;
                    width: 100%;
                }
            `
        }

        return css`
            background: ${trackColor};
            height: ${heightFromControlSize(controlSize)}px;
        `
    }}
`
